import type { TourConfig } from './types';

export const contentTour: TourConfig = {
  id: 'content-page',
  name: 'Content Management',
  description: 'Learn how to manage content for your mobile app',
  requiredPath: '/dashboard/content',
  steps: [
    {
      element: '[data-tour="content-header"]',
      popover: {
        title: 'Content Management',
        description:
          'Manage banners, transformation stories, and other content that appears in your client mobile app.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="content-add-button"]',
      popover: {
        title: 'Add New Content',
        description:
          'Click here to create new content like banners, transformation stories, tips, or recipes.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[data-tour="content-filters"]',
      popover: {
        title: 'Filter Content',
        description:
          'Use these filters to search by title, filter by content type (banner, transformation, etc.), or by status (draft, published).',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="content-table"]',
      popover: {
        title: 'Content List',
        description:
          'View all your content here. You can see the title, type, status, target audience, and creation date. Use the actions menu to view, edit, publish, or delete content.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
